import { motion } from 'framer-motion';

const TermsDisclaimer = () => {
  return (
    <motion.div 
      layout
      transition={{
        layout: { type: "spring", stiffness: 300, damping: 30 }
      }}
      className="mt-3 text-center"
    >
      <p className="text-xs text-[#8a7266]">
        By signing in to our app you agree to <span className="text-[#ff8c42] hover:underline cursor-pointer">terms</span> and <span className="text-[#ff8c42] hover:underline cursor-pointer">privacy policy</span>
      </p>
    </motion.div>
  );
};

export default TermsDisclaimer;